<template>
  <div
    v-if="founder"
    class="founder c-text founder--micro flex flex-middle bg-bg-5 gap-m border-thing-bg-4 box-shadow-1 padding-l">
    <div class="media relative margin-m-bottom flex flex-center">
      <div
        class="flex-center flex-middle padding-xs"
        style="height: 100%; width: 100%">
        <s-debug :data="displayMedia[0]"></s-debug>
        <img
          class="founder-intro-image"
          v-if="founder?.FounderMedia && founder?.FounderMedia[0]"
          style="object-fit: cover"
          :src="displayMedia[0]?.Media?.thumbUrl"
          :alt="displayMedia[0]?.title" />
      </div>
    </div>
    <div class="founder-data flex-column flex-middle text-center relative">
      <h3 class="founder-name block text-bold text-l">
        {{ translateTitleCase(founder.fullName) }}
      </h3>
      <span
        v-if="founder.originCountry && founder.originCountry != ''"
        class="founder-country block text-s text-center">
        {{ translateUcFirst(founder.originCountry) }}
      </span>
      <div class="separator block"></div>
      <span
        v-if="founder.birthYear && founder.birthYear != 0"
        class="block text-s text-center">
        <span>{{ founder.birthYear }}</span>
        <span v-if="founder.deathYear">&nbsp;-&nbsp;</span>
        <span v-if="founder.deathYear">{{ founder.deathYear }}</span>
      </span>
    </div>
    <div class="founder-zoom-container">
      <icon icon="magnify-plus" :size="2"></icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    founder: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data: function () {
    return {
      uid: new Date().getTime() + "_" + utilities.getUniqueNumber(),
      mediaSliderConfig: {
        loop: true,
        //slidesPerView: 1,
        // spaceBetween: 20,
        breakpoints: {
          767: {
            // slidesPerView: 3,
          },
        },
        pagination: false,
        observer: true,
        observeParents: true,
        parallax: true,
        // Navigation arrows
        // navigation: {
        // nextEl: ".swiper-button-next-custom",
        //prevEl: ".swiper-button-prev-custom",
        //  },
      },
    };
  },
  computed: {
    displayMedia() {
      if (
        !this.founder ||
        !this.founder.FounderMedia ||
        !Array.isArray(this.founder.FounderMedia)
      ) {
        return [];
      }

      let featuredItem = false;
      let result = [];
      this.founder.FounderMedia.forEach((item) => {
        if (item.featured) {
          featuredItem = item;
          return true;
        }

        result.push(item);
      });

      if (featuredItem) {
        result.unshift(featuredItem);
      }
      return result;
    },
  },
};
</script>

<style scoped lang="scss">
.founder--micro {
  .founder-intro-image {
    height: calc(var(--base-margin) * 90);
    width: calc(var(--base-margin) * 90);
  }

  .founder-data {
    max-width: calc(
      100% - (var(--base-margin) * 90) - (var(--base-margin) * 32) - 2 *
        (var(--base-margin) * 10)
    );
    flex: calc(
      100% - (var(--base-margin) * 90) - (var(--base-margin) * 32) - 2 *
        (var(--base-margin) * 10)
    );

    .founder-name {
      margin-bottom: var(--margin-s);
    }

    .separator {
      width: 80%;
      max-width: calc(var(--base-margin) * 60);
      height: 1px;
      background: var(--c-text);
      margin-top: var(--margin-min);
      margin-bottom: var(--margin-min);
    }

    .founder-zoom-container {
      position: absolute;
      bottom: 0;
      inset-inline-end: calc(100% + var(--margin-m));
    }
  }

  .founder-zoom-container {
    max-width: calc(var(--base-margin) * 32);
  }

  .swiper-button-prev-custom {
    position: absolute;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
    margin-inline-end: calc(100% + (var(--base-margin) * 25));
    z-index: var(--z-3);

    &::after {
      display: none;
    }
  }

  .swiper-button-next-custom {
    position: absolute;
    top: 50%;
    cursor: pointer;
    transform: translateY(-50%);
    margin-inline-start: calc(100% + (var(--base-margin) * 25));
    z-index: var(--z-3);

    &::after {
      display: none;
    }
  }
}
</style>
<style lang="scss"></style>
